import React from 'react';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 2rem;
`;

const ErrorCode = styled.h1`
  font-size: 8rem;
  margin: 0;
  font-weight: 900;
  opacity: 0.8;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
`;

const ErrorTitle = styled.h2`
  font-size: 2rem;
  margin: 0 0 1rem 0;
  font-weight: 600;
`;

const ErrorMessage = styled.p`
  font-size: 1.1rem;
  margin: 0 0 2rem 0;
  opacity: 0.9;
  max-width: 500px;
  line-height: 1.6;
`;

const HomeButton = styled.button`
  background: white;
  color: #667eea;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(255, 255, 255, 0.3);
  }
`;

const NotFoundPage: React.FC = () => {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <NotFoundContainer>
      <ErrorCode>404</ErrorCode>
      <ErrorTitle>Página Não Encontrada</ErrorTitle>
      <ErrorMessage>
        Desculpe, a página que você está procurando não existe ou foi movida. 
        Verifique o URL ou volte para a página inicial.
      </ErrorMessage>
      <HomeButton onClick={handleGoHome}>
        Voltar ao Início
      </HomeButton>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
